import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { InventoryService } from '../inventory.service';
import { GlobalResponse, DrugRequest } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-edit-dialog',
  templateUrl: './edit-dialog.component.html',
  styleUrls: ['./edit-dialog.component.css']
})
export class EditDialogComponent implements OnInit {
  public headerTitle: string;
  public doctorId: string;
  public clinicId: string;
  public drugId: string;
  public category: string;
  public name: string;
  public qty = 1;
  public price = 0;
  public batchId: string;
  public rack_no: string;
  public seller_name: string;
  public instrc: string;
  public manuf: string;
  public batchFlag = false;
  @BlockUI() blockUI: NgBlockUI;
  constructor(
    public dialogRef: MatDialogRef<EditDialogComponent>,
    private service: InventoryService
  ) { }

  ngOnInit() {
  }

  updateItem() {
    // if (this.category === 'OTHERS') {
    //   this.qty = 1;
    // }
    this.blockUI.start();
    this.service.updateDrugItem(this.seller_name, this.name, this.drugId, this.manuf, this.instrc).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        // console.log(res.result);
        this.dialogRef.close(res.result);
      }
    });
  }

  updateBatchItem() {
    // if (this.category === 'OTHERS') {
    //   this.qty = 1;
    // }
    this.blockUI.start();
    this.service.updateBatchItem(this.clinicId, this.rack_no, this.price, this.drugId, this.batchId).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        // console.log(res.result);
        this.dialogRef.close(res.result);
      }
    });
  }

}
